import { render, staticRenderFns } from "./ipBlockConfig.vue?vue&type=template&id=53c6e489&scoped=true&"
import script from "./ipBlockConfig.vue?vue&type=script&lang=js&"
export * from "./ipBlockConfig.vue?vue&type=script&lang=js&"
import style0 from "./ipBlockConfig.vue?vue&type=style&index=0&id=53c6e489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6e489",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c6e489')) {
      api.createRecord('53c6e489', component.options)
    } else {
      api.reload('53c6e489', component.options)
    }
    module.hot.accept("./ipBlockConfig.vue?vue&type=template&id=53c6e489&scoped=true&", function () {
      api.rerender('53c6e489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/safe/child/ipBlockConfig.vue"
export default component.exports